// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".col1[data-v-0d94831e],.col2[data-v-0d94831e]{border-width:.5px;border-color:#e5e7eb}.col1[data-v-0d94831e]{padding:11px 12px 12px 12px}.col2[data-v-0d94831e]{padding:11px 12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
